import requestUtil from "../request-utils.js";
import { getCustomerInfo } from "./api-customer.js";
import { getParam } from "./api-params.js";
import { callFeignV1 } from "./api-callFeign.js";
import { Message } from "element-ui";
import { getAccountInfo, getChannelInfo } from "./api-channel.js";
import i18n from "../../i18n";

/**
 * 创建充值单
 * @param {*} amount
 */
const createRecharge = (amount, giftAmount, rechargeActivityJson) => {
	return new Promise(async (resolve, reject) => {
		// 获取用户Id
		let { customerId, customerCode } = await getCustomerInfo();
		// 获取渠道信息
		let { channelId, channelName, companyId, companyName } = (await getChannelInfo()) || {};
		// 获取结算账户信息
		let { accountId, accountName } = await getAccountInfo();

		// 获取币种
		let paramList = await getParam("currencyCode");
		let currencyCode = paramList.currencyCode || "CNY";

		// 检测数据是否存在
		if (!customerId || !channelId) {
			return resolve({
				msg: i18n.t("api_utils.api_recharge.369861-0"),
			});
		}
		if (!companyId) {
			return resolve({
				msg: i18n.t("api_utils.api_recharge.369861-1"),
			});
		}
		if (!accountId) {
			return resolve({
				msg: i18n.t("api_utils.api_recharge.369861-2"),
			});
		}

		// 调用余额读取接口
		requestUtil.jackyunPost(
			{
				method: "jmall.recharge.rechargecreate",
				jsonStr: JSON.stringify({
					rechargeAmount: amount,
					customerId,
					customerCode,
					channelId,
					channelName,
					companyId,
					companyName,
					currencyCode,
					accountId,
					accountName,
					donateAmount: giftAmount || "",
					rechargeActivityJson,
				}),
			},
			res => {
				let data = {};
				if (res.code == 200) {
					data = {
						msg: "",
						rechargeNo: res.result.data && res.result.data.rechargeNo,
					};
				} else {
					console.log("创建充值单失败：", res);
					data = {
						msg: res.msg,
					};
				}
				resolve(data);
			}
		);
	});
};

/**
 * 获取待充值金额
 */
const getRechargeAmount = rechargeNo => {
	return new Promise(async (resolve, reject) => {
		// 检测数据是否存在
		if (!rechargeNo) {
			resolve(0);
		}

		// 调用余额读取接口
		requestUtil.jackyunPost(
			{
				method: "jmall.recharge.getrechargeamount",
				rechargeNo,
			},
			res => {
				let data = 0;
				if (res.code == 200) {
					data = res.result.data;
				}
				resolve(data);
			}
		);
	});
};

/**
 * 更新充值信息
 * @param {*} rechargeNo
 * @param {*} payType
 * @param {*} payAmount
 * @param {*} payNo
 */
const rechargePayConfirm = (rechargeNo, payType, payAmount, payNo) => {
	return new Promise(async (resolve, reject) => {
		// 检测数据是否存在
		if (!rechargeNo || !payType || payAmount <= 0) {
			Message.error(i18n.t("api_utils.api_recharge.369861-3"));
			resolve(false);
		}

		// 调用余额读取接口
		requestUtil.jackyunPost(
			{
				method: "jmall.recharge.rechargepayconfirm",
				amount: payAmount,
				payType,
				payNo,
			},
			res => {
				let data = false;
				if (res.code == 200 && res.result.data != false) {
					data = res.result.data;
				} else {
					console.log("充值失败：", res);
					// 原提示过长，展示不全
					if (res.msg.includes("往来单位引入失败")) {
						res.msg = i18n.t("api_utils.api_recharge.369861-4");
					}
					Message.error(res.result.data == false ? i18n.t("api_utils.api_recharge.369861-5") : res.msg);
				}
				resolve(data);
			}
		);
	});
};

/**
 * 获取充值单详情
 */
const getRechargeDetail = rechargeNo => {
	return new Promise(async (resolve, reject) => {
		// 检测数据是否存在
		if (!rechargeNo) {
			resolve({});
		}

		requestUtil.jackyunPost(
			{
				method: "jmall.recharge.getrechargedetail",
				jsonStr: JSON.stringify({
					// rechargeNo // 银联情况会更新rechargeNo，所以后面rechargeNo当做outTradeNo用，前端交互改用tradeNo
					tradeNo: rechargeNo,
				}),
			},
			res => {
				let data = {};
				if (res.code == 200) {
					data = res.result.data || {};
				} else {
					console.log("获取充值单详情失败：", res);
				}
				resolve(data);
			}
		);
	});
};

/**
 * 获取充值单状态
 * @param {*} rechargeNo
 */
const getRechargeStatus = async rechargeNo => {
	let rechargeInfo = await getRechargeDetail(rechargeNo);
	return rechargeInfo.rechargeStatus || 0;
};

/**
 * 充值活动查询 http://192.168.88.47/web/#/14/6938
 * @param {*} rechargeNo
 */
const getRechargeActivityList = async memberGrade => {
	let channelId = localStorage.getItem("pc_channelId");
	let customerId = localStorage.getItem("pc_customerId");
	return new Promise((resolve, reject) => {
		callFeignV1("crm.precharge.giftlist", {
			jsonStr: JSON.stringify({
				jsonStr: {
					vipGradeIds: [memberGrade || "-1"],
					channelIds: [channelId],
					customerId,
					status: [2], // 已生效
					walletTypes: ["-1"], // 储值卡（客户预存款）
				},
			}),
		}).then(res => {
			let data = [];
			if (res.code == 200) {
				data = res.result.data || [];
			} else {
				console.log("充值活动获取失败：", res);
			}
			resolve(data);
		});
	});
};

/**
 * 充值赠送金额计算 http://192.168.88.47/web/#/14/6938
 */
const calcRechargeGiftAmount = async (customerInfo, figure) => {
	let channelId = localStorage.getItem("pc_channelId");
	return new Promise((resolve, reject) => {
		callFeignV1("crm.precharge.eventgiftInfo", {
			jsonStr: JSON.stringify({
				jsonStr: {
					vipGradeId: customerInfo.vipLevel || "-1",
					channelId: channelId,
					figure,
					customerId: customerInfo.customerId,
					walletType: "-1", // 储值卡（客户预存款）
				},
			}),
		}).then(res => {
			let crmGiftAmount = 0;
			if (res.code == 200) {
				let data = res.result.data || {};
				crmGiftAmount = (data.giftDetailDtoArr || [])
					.filter(item => item.giftType == 0)
					.reduce((accumulator, current = {}) => accumulator + current.num, 0);
			} else {
				console.log("充值赠送金额计算失败：", res);
			}
			resolve(crmGiftAmount);
		});
	});
};

export {
	createRecharge,
	getRechargeAmount,
	rechargePayConfirm,
	getRechargeDetail,
	getRechargeStatus,
	getRechargeActivityList,
	calcRechargeGiftAmount,
};
